import { LoaderFunctionArgs } from 'react-router-dom';
import { api } from '../lib/api';
import { queryClient } from '../providers/query-client';

export async function companyLoader({ params }: LoaderFunctionArgs) {
    const companyId = params.companyId;
    if (companyId) {
        const company = await queryClient.fetchQuery({
            queryKey: ['company', companyId],
            queryFn: async () => {
                const { data } = await api.company.findOne(companyId);
                return data;
            },
        });
        return company;
    }
    return null;
}

export async function companiesLoader() {
    const companies = await queryClient.fetchQuery({
        queryKey: ['companies'],
        queryFn: async () => {
            const { data } = await api.company.findAll();
            return data;
        },
    });
    return companies;
}
